/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/contextHelpers.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Helper functions for generating context from names.
────────────────────────────────────────────────────────────────*/

export function generateContextFromName(name: string): string {
  const cleaned = name
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 50);

  return `pickup_${cleaned}`;
}

